import { config } from '../Config'
import authClient from './../modules/oktaAuth'

const accessToken = authClient.getAccessToken()

export class ExportModule {
    constructor() {}

    downloadReport(reportType, data) {
        const requestData = JSON.parse(JSON.stringify(data))

        // Best and simplies way to download a file, native HTML Form element, the most browser consistent way
        const formElement = document.createElement('form')
        formElement.action = config.ReportAPI
        formElement.method = 'POST'
        formElement.id = 'download-report'

        const hiddenInputExportType = document.createElement('input')  
        hiddenInputExportType.type = 'hidden'              
        hiddenInputExportType.name = 'type'              
        hiddenInputExportType.value = reportType
        
        const hiddenInputData = document.createElement('input')  
        hiddenInputData.type = 'hidden'              
        hiddenInputData.name = 'data'              
        hiddenInputData.value = JSON.stringify(requestData) 

        const hiddenAuthorization = document.createElement('input')  
        hiddenAuthorization.type = 'hidden'              
        hiddenAuthorization.name = 'authorization'              
        hiddenAuthorization.value = accessToken
        
        formElement.appendChild(hiddenInputExportType)
        formElement.appendChild(hiddenInputData)
        formElement.appendChild(hiddenAuthorization)

        document.body.appendChild(formElement)
        formElement.submit()
    }
}

const Export = new ExportModule()
export default Export